module.exports = __webpack_public_path__ + "img/VRCampus_Helmut.643b6231.png";